module.exports = __webpack_public_path__ + "static/media/2.b620737b.jpg";